import { Component, Input, Output, EventEmitter, ViewChild, inject, OnInit, AfterViewChecked } from '@angular/core';
import { MessageService } from 'primeng/api'; // Keep if you're still using p-toast
import { AppDataService, ConfigService, StoreService } from 'app/services';
import { CustomWindow } from 'app/@types';
import { Utils } from 'app/utils';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { Unsub } from '../../../services/unsub.class';
import { filter, takeUntil } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { StoreDto } from '../../../interfaces/store-dto.interface';
import { PartnerMartCreateStoreComponent } from '../../store-creation/partner-mart-create-store-multistep.component';

declare let window: CustomWindow;

export enum StoreGroupStatusEnum {
    All = 0,
    Regular = 1,
    Busy = 2,
    Pause = 3,
    Rejected = 4,
    Approved = 5,
    Inactive = 6
}

@Component({
    selector: 'partner-mart-locations',
    templateUrl: './partner-mart-locations.component.html',
    styleUrls: ['./partner-mart-locations.component.scss',
    '../../../../../../styles/m3-defaul-material-theme.scss',
        '../../../../../../styles/style-layout.scss'],
    providers: [MessageService]
})
export class PartnerMartLocationsComponent  extends Unsub implements OnInit, AfterViewChecked {
  public adminUrl: string = window['adminUrl'];
  public showCreateStoreSideBar = false;
  private readonly dialog = inject(MatDialog);

  @Input()
  public store: any = {};

  @Input()
  public storeId: number = 0;

  @Input()
  public merchantId: number = 0;

  @Input()
  public menuPermissionActive!: string;

  public dataSource = new MatTableDataSource<any>([]);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('detailsComponent')
  detailsComponent: any;
  selectedOption: string = 'table';
  stores: any[] = [];
  showFilterSidebar: boolean = false;



    @Output() changedVisibleFilterSidebarEmit = new EventEmitter<boolean>();
    changedVisibleFilterSidebar(increased: any) {
        this.changedVisibleFilterSidebarEmit.emit(increased);
    }

    public storeStatuses: Array<any> = [
        { name: 'All', value: StoreGroupStatusEnum.All },
        { name: 'Regular', value: StoreGroupStatusEnum.Regular },
        { name: 'Busy', value: StoreGroupStatusEnum.Busy },
        { name: 'Pause', value: StoreGroupStatusEnum.Pause },
        { name: 'Rejected', value: StoreGroupStatusEnum.Rejected },
        { name: 'Approved', value: StoreGroupStatusEnum.Approved },
        { name: 'Inactive', value: StoreGroupStatusEnum.Inactive },
    ];

  public cols: any[] = [
    { field: 'Id', header: 'Store ID', width: '150px' },
    { field: 'Name', header: 'Store Name', width: '250px' },
    { field: 'StatusName', header: 'Store Status', width: '150px' },
    { field: 'LastTx', header: 'Last Tx', width: '200px', disableSort: true },
    { field: 'MonthlyRev', header: 'Monthly Rev', width: '200px', disableSort: true },
  ];

  public displayedColumns: string[] = [
    'Id', 'Name', 'StatusName', 'LastTx', 'MonthlyRev', 'Published Status' //, 'action'
  ];

  public rowsPerPage: number = 10;
  public rowsPerPageOptions: Array<number> = [50, 100, 500, 1000];
  public totalRecords: number = 0;


  public first: number = 0;
  public pageSize: number = this.rowsPerPage;

  public sortField: string = '';
  public sortDirection: 'asc' | 'desc' | '' = 'desc';

  public isSpinnerVisible: boolean = false;
  public selectedTabIndex: number = 0;
  public selectedStore: any = null;

  private searchTimer: number = 0;
  public filter: {
        Id: number | string;
        searchName: string;
        store: string;
        lastTransactionDate: any;
        storeStatuses: Set<StoreGroupStatusEnum>;
        publishedStatus: boolean | null;
        searchTerm?: string;
  } = { Id: '', searchName: '', store: '', lastTransactionDate: null, storeStatuses: new Set<StoreGroupStatusEnum>(), publishedStatus: null, searchTerm: '' };

  public loading: boolean = false;
  public setMerchantId(value: number) {
    this.merchantId = value;
  }

  constructor(
    private messageService: MessageService,
    public configService: ConfigService,
    private storeService: StoreService,
    public appData: AppDataService
  ) {
    super();
   }

  ngOnInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    this.getStores(0, this.rowsPerPage, this.sortField, this.sortDirection);
    this.getStoresByMerchant();
  }

    ngAfterViewChecked(): void {
        if (this.sort && !this.sort.disableClear) {
            this.sort.disableClear = true;
        }
    }

  handlePageChange(event: PageEvent): void {
    this.first = event.pageIndex * event.pageSize;
    this.rowsPerPage = event.pageSize;
    this.getStores(this.first, this.rowsPerPage, this.sortField, this.sortDirection);
  }

  sortData(sort: Sort): void {
    this.sortField = sort.active;
    this.sortDirection = sort.direction;
    this.getStores(this.first, this.rowsPerPage, this.sortField, this.sortDirection);
  }

  public getStoresByMerchant() {
    const dto = {
        MerchantId: this.merchantId
    };

    this.loading = true;

    this.storeService.getStoresByMerchant(dto, this.messageService)
        .then(data => {
            if (!data.Success) {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                return;
            }
            this.stores = data.Items;
            this.loading = false;
        })
        .catch(err => {
            this.loading = false;
            throw err;
        });
    }

  protected getStores(skip: number, take: number = this.rowsPerPage,
                      sortField: string = this.sortField, sortDirection: 'asc' | 'desc' | '' = this.sortDirection): void {
    this.isSpinnerVisible = true;
      if (!sortField) {
      sortField = 'Id';
      sortDirection = 'desc';
    }

    const dto = {
      StoreCity: this.filter.store,
      LastTransactionDate: this.filter.lastTransactionDate,
      StoreStatuses: this.filter.storeStatuses.has(StoreGroupStatusEnum.All) ? [] : [...this.filter.storeStatuses],
      IsPublished: this.filter.publishedStatus,
      Skip: skip,
      Take: take,
      SortField: sortField,
      SortOrder: sortDirection === 'asc' ? 1 : -1,
      TimeZoneOffset: Utils.getTimezoneOffset(),
      SearchName: this.filter.searchName
    };

    this.storeService.getStoresForGrid(dto, this.messageService)
      .then(data => {
        if (!data) {
          this.isSpinnerVisible = false;
          return;
        }

        if (!data.Success) {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
          this.isSpinnerVisible = false;
          return;
        }

        data.Stores.map((x: any) => {
            x.PublishedStatus = x.IsPublished === true ? 'Active' : 'Inactive';
            if (x.StatusName === 'Regular') {
                x.StatusName = 'Open';
            }
            if (x.StatusName === 'Inactive') {
                x.StatusName = 'Closed';
            }
            if (!x.LastTx) {
                x.LastTx = 'No Data Available';
            }
            if (!x.MonthlyRev) {
                x.MonthlyRev = 'No Data Available';
            }
        });
        this.dataSource.data = data.Stores;
        this.totalRecords = data.TotalRecords;

        this.isSpinnerVisible = false;
      })
      .catch(error => {
        console.error('Error fetching stores:', error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load stores.' });
        this.isSpinnerVisible = false;
        throw error;
      });
  }

  public onSelectStoreClick(store: any): void {
    this.selectedStore = store;
  }

  hideDetails(){
    this.selectedStore = null;
    this.getStores(0, this.rowsPerPage, this.sortField, this.sortDirection);
    this.getStoresByMerchant();
  }

  public onPublishedStatusToggle(event: MatSlideToggleChange, store: any): void {
    const newStatus = event.checked ? 'Active' : 'Inactive';
    store.PublishedStatus = newStatus;
    this.setPublishedStatus(store, event.checked);
  }

  setPublishedStatus(store: any, status: boolean): void {
      const dto = {
          StoreId: store.Id,
          IsPublished: status,
      };
      this.storeService.updateStorePublishedStatus(dto, this.messageService)
          .then(data => {
              if (!data) {
                  this.isSpinnerVisible = false;
                  return;
              }

              if (!data.Success) {
                  this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                  this.isSpinnerVisible = false;
                  return;
              }

              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Published status successfully updated.' });
              this.isSpinnerVisible = false;
          })
          .catch(error => {
              console.error('Error:', error);
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update published status.' });
              this.isSpinnerVisible = false;
              throw error;
          });
  }

  public handleFilterChange(): void {
    if (this.searchTimer) {
      window.clearTimeout(this.searchTimer);
    }
    this.dataSource.data = [];
    this.totalRecords = 0;
    // Parse the search term
    const term = (this.filter.searchTerm || '').trim();
    if (term === '') {
      this.filter.Id = '';
      this.filter.searchName = '';
    } else if (/^\d+$/.test(term)) {
      this.filter.Id = term;
      this.filter.searchName = '';
    } else {
      this.filter.Id = '';
      this.filter.searchName = term;
    }
    this.filter.searchName = term;

    this.searchTimer = window.setTimeout(() => {
    this.paginator.firstPage();
    this.getStores(0, this.rowsPerPage, this.sortField, this.sortDirection);
    this.searchTimer = 0;
    }, 500);
  }

    showFilter() {
        this.showFilterSidebar = true;
    }

    addStoreStatus(add: boolean, statusValue: StoreGroupStatusEnum) {
        if (statusValue === StoreGroupStatusEnum.All) {
            this.filter.storeStatuses = new Set<StoreGroupStatusEnum>();
            this.filter.storeStatuses.add(statusValue);
        } else {
            if (add) {
                this.filter.storeStatuses.add(statusValue);
            } else {
                this.filter.storeStatuses.delete(statusValue);
            }
            this.filter.storeStatuses.delete(StoreGroupStatusEnum.All);
        }
    }

    public clearFilter() {
        this.filter = {Id: '',searchName: '',store: '',lastTransactionDate: null,storeStatuses: new Set<StoreGroupStatusEnum>(),publishedStatus: null, searchTerm: ''};
        this.getStores(0, this.rowsPerPage, this.sortField, this.sortDirection);
    }
    private get defaultDialogConfig(): MatDialogConfig {
    return {
      width: '80%',
      maxWidth: '100vw',
      closeOnNavigation: false,
      disableClose: true,
    };
  }

 public openCreateStoreSideBar() {
  const dialogRef = this.dialog.open(PartnerMartCreateStoreComponent, {
    width: '80%',
    maxWidth: '100vw',
    panelClass: 'custom-dialog-container',
    data: { stores: this.stores },
    disableClose: true,  // optional
    autoFocus: false
  });

  dialogRef
    .afterClosed()
    .pipe(
      takeUntil(this.unsubscribe$),
      filter((store) => !!store)
    )
    .subscribe((store: StoreDto) => {
        this.getStores(0, this.rowsPerPage, this.sortField, this.sortDirection);
        this.getStoresByMerchant();
    });
   }
      addNewlyAddedStore(store: StoreDto): void {
        const stores = this.stores || [];
        this.stores = [store, ...stores];
      }

    changedShowCreateStoreSideBarEmit(value: any) {
        this.showCreateStoreSideBar = value;
    }

    public onTabChange(event: any): void {
        this.selectedTabIndex = event.index;
    }
}

